import type { NodeFieldRenderDeps } from './nodeRenderers.js';
import { markNodeDragHandle } from './nodeDragHandles.js';

function createNodeDragRow(...classNames: string[]): HTMLDivElement {
  const row = document.createElement('div');
  row.classList.add(...classNames);
  markNodeDragHandle(row);
  return row;
}

export function createNodePortRow(...extraClassNames: string[]): HTMLDivElement {
  return createNodeDragRow('port-row', ...extraClassNames);
}

export function createNodeFieldRow(...extraClassNames: string[]): HTMLDivElement {
  return createNodePortRow('value-row', ...extraClassNames);
}

export function createValueSectionRow(title: string): HTMLDivElement {
  const row = createNodeFieldRow('value-row--section');
  row.appendChild(createNodeDragLabel('value-section-label', title));
  return row;
}

export function createNodeDragLabel(className: string, text: string): HTMLSpanElement {
  const label = document.createElement('span');
  label.className = className;
  markNodeDragHandle(label, 'descendants');
  label.textContent = text;
  return label;
}

export function createNodeValueLabel(text: string): HTMLSpanElement {
  return createNodeDragLabel('port-label value-field-label', text);
}

export function createNodePortLabel(text: string, io: 'in' | 'out' = 'in'): HTMLSpanElement {
  return createNodeDragLabel(io === 'out' ? 'port-label out' : 'port-label', text);
}

export function createNodeFieldSelect(width: string): HTMLSelectElement {
  const select = document.createElement('select');
  select.className = 'node-value-input';
  select.style.width = width;
  select.addEventListener('mousedown', e => e.stopPropagation());
  return select;
}

export function createNodeFieldTextInput(
  value: string,
  onChange: (value: string) => void,
): HTMLInputElement {
  const input = document.createElement('input');
  input.className = 'node-value-input';
  input.type = 'text';
  input.value = value;
  input.style.width = '100%';
  input.addEventListener('mousedown', e => e.stopPropagation());
  input.addEventListener('change', () => onChange(input.value));
  return input;
}

export function makeNodeFieldPortRow(
  io: 'in' | 'out',
  portIndex: number,
  type: string,
  label: string,
  nodeId: string,
  deps: NodeFieldRenderDeps,
): HTMLElement {
  const row = createNodePortRow();
  const dot = document.createElement('div');
  dot.className = `port-dot ${io} type-${type}`;
  dot.dataset.node = nodeId;
  dot.dataset.port = String(portIndex);
  dot.dataset.io = io;
  const lbl = createNodePortLabel(label, io);
  if (io === 'out') {
    row.appendChild(lbl);
    row.appendChild(dot);
  } else {
    row.appendChild(dot);
    row.appendChild(lbl);
  }
  deps.setupPortDrag(dot);
  return row;
}
